// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"dashboard_dashboard__3MJQz","dashboardCol":"dashboard_dashboardCol__ueZrt","fade-in":"dashboard_fade-in__BZ2MW"};